// extracted by mini-css-extract-plugin
export default {"header":"styles_header__C+SPP","logo":"styles_logo__mSiZ5","accountAvatar":"styles_accountAvatar__ExJ6g","signOut":"styles_signOut__pqzZk"};